import * as React from "react";
const SvgEmptyStatePurchases = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 159.171,
	height: 122.799,
	viewBox: "0 0 159.171 122.799",
	...props
}, /* @__PURE__ */ React.createElement("g", {
	id: "Group_28",
	"data-name": "Group 28",
	transform: "translate(-0.296 -56.123)"
}, /* @__PURE__ */ React.createElement("path", {
	id: "Path_635",
	"data-name": "Path 635",
	d: "M197,627.709H125.274v-.516h71.208V602.167H131.3l-3.166-6.6.465-.224,3.026,6.3H197Z",
	transform: "translate(-87.327 -462.451)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_76",
	"data-name": "Ellipse 76",
	cx: 5.418,
	cy: 5.418,
	r: 5.418,
	transform: "translate(42.075 167.064)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_77",
	"data-name": "Ellipse 77",
	cx: 5.418,
	cy: 5.418,
	r: 5.418,
	transform: "translate(95.481 167.064)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_636",
	"data-name": "Path 636",
	d: "M313.711,534.549H233.092l-17.444-57.018H331.675l-.106.336Zm-80.237-.516h79.858l17.64-55.987H216.346Z",
	transform: "translate(-196.368 -403.348)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_637",
	"data-name": "Path 637",
	d: "M168.392,463.583H97.582L82.26,413.015H184.171l-.093.3Z",
	transform: "translate(-57.343 -335.349)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_638",
	"data-name": "Path 638",
	d: "M450.317,354.86l-.5-.132,3.4-12.834H473.03v.516H453.62Z",
	transform: "translate(-313.564 -285.771)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1258",
	"data-name": "Rectangle 1258",
	width: 104.592,
	height: .516,
	transform: "translate(24.917 91.47)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1259",
	"data-name": "Rectangle 1259",
	width: 92.787,
	height: .516,
	transform: "translate(30.733 110.48)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1260",
	"data-name": "Rectangle 1260",
	width: .516,
	height: 56.502,
	transform: "translate(77.034 74.441)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1261",
	"data-name": "Rectangle 1261",
	width: 56.622,
	height: .516,
	transform: "matrix(0.065, -0.998, 0.998, 0.065, 96.949, 130.927)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1262",
	"data-name": "Rectangle 1262",
	width: .516,
	height: 56.622,
	transform: "translate(53.427 74.458) rotate(-3.729)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1263",
	"data-name": "Rectangle 1263",
	width: 159.171,
	height: .677,
	transform: "translate(0.296 178.245)",
	fill: "#2f2e41"
})));
export default SvgEmptyStatePurchases;
